/**
 * Direct Iterator utils for use cases where first converting to an Array is too costly in performances/memory.
 */

/**
 * @returns The number of items satisfying the predicate
 */
export function count<T>(
  iterator: IterableIterator<T>,
  predicate: (value: T) => boolean,
) {
  let count = 0
  let result = iterator.next()

  while (!result.done) {
    if (predicate(result.value)) count++
    result = iterator.next()
  }

  return count
}

/**
 * @returns The first item satisfying the predicate
 */
export function find<T, U extends T>(
  iterator: IterableIterator<T>,
  predicate: (value: T) => value is U,
): U | undefined
export function find<T>(
  iterator: IterableIterator<T>,
  predicate: (value: T) => boolean,
): T | undefined {
  let result = iterator.next()

  while (!result.done) {
    if (predicate(result.value)) return result.value
    result = iterator.next()
  }

  return undefined
}
